module.exports = __webpack_public_path__ + "static/frogponds-61787d123bc85b389132b58a9ff2f77e.png";